var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field--text-dark mb-2"},[_vm._v(" Password must be at least 8 characters long and contain: at least x1 uppercase letter, x1 lowercase letter, x1 number, and x1 special character. ")])}
var staticRenderFns = []

export { render, staticRenderFns }